import { Fragment } from 'react';
import RegistrationStepHeading from './RegistrationStepHeading';
import Stepper from './Stepper/Stepper';
import RegistrationFormFooter from './RegistrationFormFooter';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { FormWithTracking } from 'components/Form/FormWithTracking';
import Flex from 'style-utils/components/Flex';
import {
  useIsAtLeastDesktopBreakpoint,
  useIsAtleastTabletBreakpoint,
} from 'utils/hooks/media-queries';
import {
  getCmsContent,
  buildContentImageLink,
} from 'utils/functions/getCmsContent';

type RegistrationFormSkeletonProps<T extends object> = {
  stepHeading: string;
  activeStep?: number;
  goBackUrl?: string;
  isDisabled?: boolean;
  children: React.ReactNode;
  methods: UseFormReturn<T>;
  handleSubmit: (
    e?: React.BaseSyntheticEvent<object, any, any> | undefined,
  ) => Promise<void>;
};

const RegistrationFormSkeleton = <T extends object>(
  props: RegistrationFormSkeletonProps<T>,
) => {
  const {
    stepHeading,
    activeStep,
    goBackUrl,
    methods,
    isDisabled,
    handleSubmit,
    children,
  } = props;

  const isDesktop = useIsAtLeastDesktopBreakpoint();
  const isTablet = useIsAtleastTabletBreakpoint();

  const { data } = getCmsContent();
  const bannerSmall = data?.['banner-small'];

  return (
    <Fragment>
      {!isDesktop && bannerSmall && (
        <Flex
          justifyContent={'center'}
          m={'0 auto 2.4rem'}
          maxW={isTablet ? '32.8rem' : undefined}
        >
          <img
            src={buildContentImageLink(bannerSmall)}
            alt="Registration Banner"
            width={'100%'}
          />
        </Flex>
      )}
      <RegistrationStepHeading i18nKey={stepHeading} />
      <Stepper activeStep={activeStep} />
      <FormProvider {...methods}>
        <FormWithTracking
          maxW={isTablet ? '32.8rem' : undefined}
          m={'2rem auto 0'}
          onSubmit={handleSubmit}
          eventType="registration-error"
        >
          {children}
          <RegistrationFormFooter
            goBackUrl={goBackUrl}
            isDisabled={isDisabled}
          />
        </FormWithTracking>
      </FormProvider>
    </Fragment>
  );
};

export default RegistrationFormSkeleton;
